// extracted by mini-css-extract-plugin
module.exports = {"container":"bs_e"};